// extracted by mini-css-extract-plugin
export default {"input":"mantineSelect_input__hnufm","dropdown":"mantineSelect_dropdown__t+nur","option":"mantineSelect_option__aSGb8"};